import { base64Encode } from '@canvas/encoding';
import { browserTracingIntegration, init } from '@canvas/sentry-react';

export const initializeSentry = () => {
  const buildVersion: HTMLMetaElement | null = document.querySelector(
    'meta[name="build-version"]'
  );

  init({
    dsn: process.env.SENTRY_DSN,
    environment: process.env.SENTRY_ENV,
    integrations: [browserTracingIntegration()],
    // Disable console breadcrumbs to avoid logging PII
    beforeBreadcrumb: (breadcrumb) =>
      breadcrumb.category === 'console' ? null : breadcrumb,
    ignoreErrors: [/ResizeObserver loop limit exceeded/],
    release:
      buildVersion === null || buildVersion === undefined
        ? 'unknown-version'
        : buildVersion.content,
    beforeSend: (event) => {
      // eslint-disable-next-line no-underscore-dangle
      if (event.extra?.__serialized__) {
        // Avoid filtering of the serialized content of non-Error objects
        // eslint-disable-next-line no-underscore-dangle
        event.extra.base64 = base64Encode(JSON.stringify(event.extra?.__serialized__));
      }

      return event;
    },
  });
};
